/**
 * @flow
 * @format
 */

import _PieChart from './PieChart';

export default _PieChart;



// WEBPACK FOOTER //
// ./src/components/PieChart/index.js